<template>
  <div class="detail-body" @click.stop="closeewm($event)">
    <div class="top-bg-img">
        <!-- <img src="../../assets/shared-hotel/cardbalancebg.png" alt="" /> -->
        <!-- <div class="top-bg-op"></div> -->
    </div>
    <nav-bar titleText="卡包余额" fontColor="#ffffff" :whiteBack="true" bg="#fb761d" @goBack="goBack"></nav-bar>
 
    <div class="supermark-datail-info-div">
      <div class="supermark-detail-info-top">
          <div class="supermark-detail-info-top-title">卡包余额</div>
          <div class="supermark-detail-info-top-money">{{data.balance}}</div>
      </div>
      <div class="supermark-detail-info-center">
          <div class="supermark-detail-info-item">
              <div class="supermark-detail-info-item-title">
                  共享额度
                  <img src="../../assets/shared-hotel/tips.png" class="tips" alt="" @click.stop="cuttip(1)"/>
                  <span class="tiptext" v-if="isshare">指可以去加入共享饭店消费的通用额度</span>
              </div>
              <div class="supermark-detail-info-item-money interval">{{data.balance_amount}}</div>
          </div>
          <div class="supermark-detail-info-item">
              <div class="supermark-detail-info-item-title">
                  赠送额度
                  <img src="../../assets/shared-hotel/tips.png" class="tips" alt="" @click.stop="cuttip(2)"/>
                  <span class="tiptext" v-if="isgiva">指到商家充值赠送的金额，赠送金额只能到对应的充值商家使用</span>
              </div>
              <div class="supermark-detail-info-item-money" @click="skip()">
                  {{data.awards_sum}}
                  <img src="../../assets/shared-hotel/skipright.png" :class="client==11?'skiprights':'skipright'" alt=""/>
              </div>
          </div>
      </div>
    </div>
    <div class="supermark-content" :style="scrollpositionStyle">
        <!-- <div class="supermark-search">
            <div class="supermark-searchitem">
                <span>全部时间</span>
                <img src="../../assets/shared-hotel/packup_bottom.png" alt=""/>
            </div>
            <div class="supermark-searchitem">
                <span>全部类型</span>
                <img src="../../assets/shared-hotel/packup_bottom.png" alt=""/>
            </div>
        </div> -->
        <van-dropdown-menu   active-color="#F9591B" >
            <van-dropdown-item @open="appDomscroll()" :title="start_date==''?'全部时间':start_date.replace(/-/g,'.')+'-'+end_date.replace(/-/g,'.')" ref="timeitem" >
                <van-datetime-picker
                    v-model="startDate"
                    type="date"
                    :default-index="1"
                    :visible-item-count="3"
                    v-show="isshowtime"
                    >
                    <template v:slot="cancel">
                        <div class="btn_cancel" @click="onCancel()">取消</div>
                    </template>
                    <template v:slot="confirm">
                        <div class="btn_confirm" @click="nextstep()">下一步</div>
                    </template>
                </van-datetime-picker>
                <van-datetime-picker
                    v-model="endDate"
                    type="date"
                    :default-index="1"
                    :visible-item-count="3"
                    v-show="!isshowtime"
                    :min-date="minDate"
                    >
                    <template v:slot="cancel">
                        <div class="btn_cancel" @click="isshowtime=true">上一步</div>
                    </template>
                    <template v:slot="confirm">
                        <div class="btn_confirm" @click="onConfirm()">完成</div>
                    </template>
                </van-datetime-picker>
            </van-dropdown-item>
            <van-dropdown-item @open="appDomscroll()" v-model="value" :options="option" ref="typeitem" @change="typechange()" />
        </van-dropdown-menu>
    </div>
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list v-model="loading" :finished="finished" :finished-text="finishedText" @load="onLoad" v-if="list.length > 0" style="min-height: 818px;padding:0 12px;box-sizing: border-box;">
                <div class="list-item" v-for="(item, i) in list" :key="i" @click="skipdetail(item)">
                    <div class="title">
                        <span class="left">{{item.is_admin==0?(item.type==1?'共享饭店卡包充值':'共享饭店卡包核销'):(item.type==1?'平台操作增加':'平台操作扣减')}}</span>
                        <span class="price">{{item.type==1?`+${parseFloat(item.order_amount).toFixed(2)}`:`-${parseFloat(item.order_amount).toFixed(2)}`}}</span>
                    </div>
                    <div class="items">{{item.created_at}}</div>
                    <div class="items" v-if="item.is_admin==0">{{item.shop_name}}</div>
                    <div class="remark" v-if="item.is_admin!=0">备注：{{item.comment}}</div>
                    <div class="items" v-if="item.is_admin==0&&item.type==1">充{{item.actual_amount}}送{{item.present_amount}}</div>
                    <div class="info" v-if="item.is_admin==0&&item.type==2">
                        <!-- <span class="left">核销信息：</span> -->
                        <span class="right">
                            <p class="right-p">共享金额 -{{item.actual_amount}}</p>
                            <p>赠送金额 -{{item.present_amount}}</p>
                        </span>
                    </div>
                </div>

        </van-list>

        <div class="empty" v-if="list.length === 0">
            <img src="../../assets/shared-hotel/empty.png" alt="">
            <p>暂无结果</p>
        </div>
    </van-pull-refresh>
  </div>
</template>

<script>
import navBar from './components/navBar'
export default {
    name:"cardbalance",
    data(){
        return{
            list: [],
            loading: false,
            finished: false,
            refreshing: false,
            page: 0,
            pageSize:10,
            isshare:false,
            isgiva:false,
            scrollpositionStyle:'',
            fn: null,
            isshowtime:true,
            startDate: new Date(),
            endDate: new Date(),
            start_date:'',
            end_date:'',
            minDate: new Date(),
            value: 0,
            option: [
                { text: '全部类型', value: 0 },
                { text: '充值记录', value: 1 },
                { text: '消费记录', value: 2 },
            ],
            data:{},//余额信息
            client: 0,
        }
    },
    components:{
        navBar,
    },
    computed: {
        finishedText(){
        if (this.list.length && ! this.loading && ! this.refreshing) {
            return '- 没有更多了 -'
        }
        return ''
        },
    },
    created(){
        this.getcardmoney();
        this.getRecordList();
        this.deductionUA()
    },
    mounted() {
        const appDom = document.querySelector('.detail-body')
        this.fn = (e) => {
            if (appDom.scrollTop > 240) {
                this.scrollpositionStyle='position: fixed;top: 88px;right: 0;left: 0;z-index:1;'
            }else{
                this.scrollpositionStyle=''
            }
        }
        appDom.addEventListener('scroll', this.fn, false)
    },
    destroyed() {
        const appDom = document.querySelector('body')
        appDom.removeEventListener('scroll', this.fn, false)
    },
    methods:{
        deductionUA() {
            let ua = navigator.userAgent.toLowerCase();
            if (/iphone|ipad|ipod|macintosh/i.test(ua)) {
                this.client = 11
            } else if (/android/.test(ua)) {
                this.client = 10
            }
        },
        getcardmoney(){
            this.$api.get('offshop/member/canteen/membership-card').then((res)=>{
                this.data=res
            });
        },
        appDomscroll(){
            const appDom = document.querySelector('.detail-body')
            appDom.scrollTop = 237
        },
        onCancel(){
            this.start_date='';
            this.end_date='';
            this.$refs.timeitem.toggle();
            this.refreshing = true;
            this.onRefresh();
        },
        onConfirm(){
           this.end_date=this.formatDate(this.endDate);
           this.isshowtime=true;
           this.$refs.timeitem.toggle(); 
           this.refreshing = true;
           this.onRefresh();
        },
        nextstep(){
            this.start_date=this.formatDate(this.startDate);
            this.minDate=new Date(this.start_date.replace(/-/g,'/'))
            this.isshowtime=false
            console.log(this.start_date,this.minDate,"lllll");
        },
        typechange(){
           this.refreshing = true;
           this.onRefresh(); 
        },
        onLoad() {
            this.getRecordList();
        },
        onRefresh() {
            this.page = 0;
            this.onLoad();
        },
        getRecordList() {
            this.page ++
            let params = {
                type: this.value,
                start_date:this.start_date,
                end_date:this.end_date,  
                page: this.page,
                pageSize:this.pageSize,
            }
            
            this.$api.post("/offshop/member/canteen/membership-card/record", params).then((res) => {
                let _list = res.list
                if (this.refreshing) {
                this.list = [];
                this.finished = false;
                }

                this.list.push(..._list)

                if (this.list.length === 0 || _list.length === 0) {
                this.finished = true;
                this.loading = false;
                this.refreshing = false;
                return;
                }

                this.loading = false;

                if (res.current_page == res.last_page) {// 数据全部加载完成
                this.finished = true;
                }

                if (this.refreshing) {
                this.$toast("刷新成功");
                this.refreshing = false;
                }

                if (! this.finished && ! this.loading && this.list.length <= 4) {
                this.onLoad()
                }
                
            })
            .catch(()=>{
                this.loading = false;
                this.refreshing = false;
                this.finished = true
            })
        },
        goBack() {
            this.$router.go(-1)
        }, 
        cuttip(num){
            this.isshare=false;
            this.isgiva=false;
            if(num==1){
                this.isshare=!this.isshare;
            }else if(num==2){
                this.isgiva=!this.isgiva;
            }
        },
        closeewm(){
            this.isshare=false;
            this.isgiva=false;
        },
        skip(){
            this.$router.push({
                path: "/sharedHotel/givingCredits"
            });
        },
        skipdetail(item){
            this.$router.push({
                path: "/sharedHotel/cardbalanceDetail",
                query: {
                    item: JSON.stringify(item)
                },
            });
        }
    }
}
</script>

<style lang="less">
.detail-body{
        .van-dropdown-item__content{
        padding-bottom: 50px;
    }
    .van-picker__toolbar{
        border-top:1px solid #eeeeee;
        position: absolute;
        bottom:-50px;
        left:0;
        right:0;
        .btn_confirm{
            font-size: 16px;
            font-weight: 400;
            color: #F9591B;
            padding: 0 60px;
            box-sizing: border-box;
        }
        .btn_cancel{
            font-size: 16px;
            font-weight: 400;
            color: #999999;
            padding: 0 60px;
            box-sizing: border-box;
        }
    } 
    .van-dropdown-menu__bar{
        background: #f5f5f5;
        height:60px;
        line-height: 70px;
        box-shadow:none;
        display: block;
        padding: 0 12px;
        box-sizing: border-box;
    }
    .van-dropdown-menu__item{
        display: inline-block;
    }
    .van-dropdown-menu__item+.van-dropdown-menu__item{
        margin-left: 10px;
    }
    .van-dropdown-menu__title{
        display: inline-block;
        padding: 5px 25px 5px 15px;
        box-sizing: border-box;
        background: #fff;
        border-radius: 15px;
        font-size: 14px;
    }
    .van-dropdown-menu__title::after{
        border-color: transparent transparent #333333 #333333;
        right: 12px;
    }  
    .van-dropdown-menu__title--active::after{
        border-color:transparent transparent #F9591B #F9591B
    }
    .van-cell__title{
        text-align: center;
    }
    .van-cell__value{
        display: none;
    }
    .van-dropdown-item__option{
        color: #999999;
        font-size: 16px;
    } 
    .van-dropdown-item__option--active{
        color: #333333 !important;
        font-size: 16px;
        font-weight: 600;
    }
}

</style>
<style lang="less" scoped>
.detail-body{
    position: relative;
    background: #f5f5f5;
    height: 100%;
    padding-top: 88px;
    box-sizing: border-box;
    overflow-y: auto;
    .top-bg-img {
        position: absolute;
        width: 100%;
        height: 238px;
        z-index: 0;
        top: 0;
        // background: linear-gradient(
        //     180deg,
        //     rgba(0, 0, 0, 0.5) 0%,
        //     rgba(255, 255, 255, 0) 100%
        // );
        background: linear-gradient(360deg, rgba(255, 152, 31, 0) 0%, #FF981F 11%, #F9591B 100%);

        img {
            height: 156px;
            width: 100%;
            object-fit: cover;
        }
    }
    .top-bg-op {
        position: absolute;
        z-index: 99;
        top: 0;
        background: linear-gradient(360deg, rgba(255, 152, 31, 0) 0%, #FF981F 11%, #F9591B 100%);
        width: 100%;
        height: 100%;
    }
    .supermark-datail-info-div {
        position: relative;
        margin: 0 auto 0;
        width: 94%;
        box-shadow: 1px 3px 11px 0px rgba(0, 0, 0, 0.05);
        border-radius: 8px;
        z-index: 10;
        background-color: #fff;
        padding: 40px 0;
        box-sizing: border-box;
        .supermark-detail-info-top{
            text-align: center;
            padding-bottom: 40px;
            box-sizing: border-box;
            .supermark-detail-info-top-title{
                font-size:15px;
                font-weight: 400;
                color: #999999;
            }
            .supermark-detail-info-top-money{
                font-size: 32px;
                font-weight: 600;
                color: #FC740C;
            }
        }
        .supermark-detail-info-center{
            display: flex;
            .supermark-detail-info-item{
                flex: 1;
                text-align: center;
                .supermark-detail-info-item-title{
                    font-size:15px;
                    font-weight: 400;
                    color: #999999;
                    position: relative;
                    .tips{
                        width: 15px;
                        height: 15px;
                        position: absolute;
                        top:3px;
                        margin-left: 2px;
                    }
                    .tiptext{
                        position: absolute;
                        top: 28px;
                        left: 0px;
                        z-index: 999;
                        font-size: 14px;
                        font-weight: 400;
                        padding: 12px;
                        box-sizing: border-box;
                        border-radius: 6px;
                        color: #ffffff;
                        background: rgba(0, 0, 0, 0.7);
                    }
                    .tiptext::after {
                        content: "";
                        position: absolute;
                        top: -9px;
                        right: 42px;
                        width: 0;
                        height: 0;
                        border-left: 6px solid transparent;
                        border-right: 6px solid transparent;
                        border-bottom: 9px solid rgba(0, 0, 0, 0.7);
                    }
                }
                .supermark-detail-info-item-money{
                    font-size: 20px;
                    font-weight: 600;
                    color: #333333;
                    padding: 5px 0;
                    box-sizing: border-box;
                    position: relative;
                    .skipright{
                        width: 12px;
                        height: 12px;
                        position: absolute;
                        top:10px;
                    }
                    .skiprights{
                       width: 12px;
                        height: 12px;
                        position: absolute;
                        top:12px; 
                    }
                }
                .interval{
                    border-right:1px solid #eeeeee;
                }
            }
        }
    }
    .supermark-content{
        // position: sticky;
        // top: 108px;
        // margin-top: 100px;
        background: #F5F5F5;
        .supermark-search{
            padding: 15px 12px;
            box-sizing: border-box;
            .supermark-searchitem{
                display: inline-block;
                background: #FFFFFF;
                border-radius: 15px;
                font-size: 15px;
                font-weight: 400;
                color: #333333;
                padding: 5px 33px 5px 23px;
                box-sizing: border-box;
                margin-right: 10px;
                position: relative;
                img{
                    width: 8px;
                    position: absolute;
                    top:12px;
                    right:20px;
                }
            }
        }
        
    }
    .list-item {
            width: 100%;
            padding: 10px 12px;
            box-sizing: border-box;
            background-color: #fff;
            margin-bottom: 10px;
            border-radius: 6px;
            .title {
                margin-bottom: 8px;
                display: flex;
                justify-content: space-between;
                .left {
                    flex: 1;
                    font-size: 15px;
                    font-weight: 400;
                    color: #333333;
                }
                .date {
                    width: 133px;
                }
                .price {
                    font-size: 18px;
                    font-weight: 600;
                    color: #333333;
                }
            }
            .items{
                width: 320px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                font-size: 15px;
                font-weight: 400;
                color: #999999;
                margin-bottom: 6px;
            }
            .info {
                display: flex;
                margin-bottom: 10px;
                font-weight: 400;
                color: #999999;
                .right-p{
                    margin-bottom: 6px;
                } 
            }
            .remark{
                font-size: 14px;
                font-weight: 400;
                color: #666666;
                padding: 10px;
                box-sizing: border-box;
                background: #F5F6F7;
                border-radius: 2px;
            }
        }
        .empty {
            width: 100%;
            height: 818px;
            img {
            width: 100%;
            padding: 105px 47px 19px;
            box-sizing: border-box;
            }
            p:nth-of-type(1) {
            width: 100%;
            text-align: center;
            font-size: 15px;
            color: #999999;
            }
        }
}

</style>